// ترتیبِ این دو import مهمه: boot باید اول باشه تا initCore قبل از هر چیزی که
// از core می‌آد صدا زده شده باشه. نگاه کن به بالای src/boot.ts.
import './boot';
import './ui/base.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';

const el = document.getElementById('root');
if (!el) throw new Error('#root نیست — index.html دست‌کاری شده؟');

createRoot(el).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
